import { EnvironmentVariables } from "@/modules/common/types";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext } from "react";

const useShareLeadWhatsapp = () => {
  const { lead } = useContext(LeadPageContext);

  const handleLeadWhatsappShare = () => {
    const leadUrl = `${EnvironmentVariables.CRM_NAVIGATE_URL}/leads/${lead?.data?.lead.journey_uid}`;
    const encodedMessage = encodeURIComponent(leadUrl);

    window.open(`https://wa.me/?text=${encodedMessage}`, "_blank");
  };

  return {
    handleLeadWhatsappShare,
  };
};

export default useShareLeadWhatsapp;
